import { css } from 'lit';

export default css`
  .content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .quit-dialog-content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
`;
